<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { usePartnerStore } from '@/stores/usePartnerStore'
import LoaderCenter from '@/components/common/feedback/LoaderCenter.vue'
import { isSiretOrSiren } from '@/utils/textUtils'
const location = useRoute()
const router = useRouter()

const partnerStore = usePartnerStore()
const { searchValue, loading } = storeToRefs(partnerStore)
const errorMessage = ref('')

const searchSiret = (searchText: string) => {
  if (!searchText || searchText.length < 3) {
    errorMessage.value = '3 caractères minimum'
    return
  }
  searchText = searchText.trim()

  if (location.fullPath != '/search') router.push('/search')
  if (isSiretOrSiren(searchText)) {
    searchValue.value = searchText.replace(/\s/g, '')
    partnerStore.searchSiret(searchValue.value)
  } else {
    partnerStore.searchPartnerByText(searchText)
  }
}
</script>

<template>
  <div class="relative m-3 border-none">
    <label class="input rounded-2xl flex items-center gap-2">
      <input
        type="text"
        v-model="searchValue"
        class="grow align-middle px-1 font-semibold text-primary"
        placeholder="Recherche"
        @keyup.enter="searchSiret(searchValue)"
      />
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        fill="#185a7c"
        class="h-4 w-4 opacity-70 cursor-pointer"
        @click="searchSiret(searchValue)"
        v-if="searchValue.length > 2 && !loading"
      >
        <path
          fill-rule="evenodd"
          d="M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
          clip-rule="evenodd"
        />
      </svg>
      <div class="w-4" v-else-if="loading">
        <loader-center></loader-center>
      </div>
      <div class="w-4 h-4" v-else></div>
    </label>
    <!-- Error message -->
    <p v-if="errorMessage" class="absolute left-0 mt-1 text-sm text-red-500">
      {{ errorMessage }}
    </p>
  </div>
</template>
